<template>
  <div class="registerbox">
    <div class="bgbox">
      <!-- 背景图里面的轮播图和注册盒子 -->
      <div class="w1050 flex">
        <!-- 轮播盒子 -->
        <div class="bannerbox">
          <div class="block">
            <el-carousel height="520px" indicator-position="none" arrow="never">
              <el-carousel-item v-for="(x,i) in registerImgArr" :key="i">
                <div class="imgbox">
                  <a :href="x.href"><img  width="562px" height="520px" :src="x.src" :title="x.title" :alt="x.alt" />{{x}}</a>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 注册盒子 -->
        <div class="regbox">
          <p class="titlename">注册<a class="gologin" @click="goLogin()">登录</a></p>
          <el-form :model="registerForm" :rules="rules" ref="registerForm">
            <p class="inputbox" v-for="(x,i) in forminput" :key="i">
              <el-form-item :prop="x.name">
                <el-input class="inputItem" v-if="x.type==='input'" v-model="registerForm[x.name]" :placeholder="x.string" :show-password="x.password"></el-input>
                <div class="areaBox" v-else-if="x.type==='selects'">
                  <el-select v-model="placeData[0]" clearable @change="remoteMethod($event, 1)" placeholder="省">
                    <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
                  </el-select>
                  <el-select v-model="placeData[1]" clearable @change="remoteMethod($event, 2)" placeholder="市">
                    <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
                  </el-select>
                  <el-select v-model="placeData[2]" clearable @change="remoteMethod($event, 3)" placeholder="县">
                    <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <i class="iconfont">{{x.icon}}</i>
              <el-button v-if="x.button" type="info" plain :disabled="x.disabled" @click="sendCode(x)">{{x.btnstr}}</el-button>
            </p>
            <el-button class="registerbtn" type="primary" @click="subRegister()">立即注册</el-button>
            <p class="info">注册代表您已同意<a style="color:#1E9FFF">《竞成声明》</a></p>
            <p class="info"><a style="color:#1E9FFF;cursor: pointer;" @click="goLogin()">已有账号，直接登录</a></p>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 背景图下面的四个盒子 -->
    <div class="w1200">
      <ul class="flex">
        <li v-for="(x,i) in titleArr" :key="i">
          <span class="yuan" :style="{'border-color':x.color}"><i class="iconfont" :style="{'color':x.color}">{{x.icon}}</i></span>
          <span class="cont"><p class="title">{{x.title}}</p><p class="str">{{x.str}}</p></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [mixin_area],
  data() {
    let isPhone = (rule, value, callback) => {
      let reg=/^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!reg.test(value)) {callback(new Error('手机号码不符合规范'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        name: [
          { required: 'true', message: '账号不能为空', trigger: 'blur' },
          { validator: isPhone,trigger:'blur'}
        ],
        password: [
          { required: 'true', message: '密码不能为空', trigger: 'blur' },
          { min: 6, max: 16, message: '密码长度在 6 到 16 个字符之间', trigger: 'blur' }
        ],
        userCode: [
          { required: 'true', message: '验证码不能为空', trigger: 'blur' },
        ],
        // isOrganization: [
        //   { required: 'true', message: '注册账户类型不能为空', trigger: 'blur' }
        // ],
      },
      bannerImgArr: [1,2,3,4,5],//注册页面轮播图数组
      registerForm: {},
      province: [],//表单里面的 省市县 的下拉框选项
      city: [],
      county: [],
      placeData: [{areaId:''}, {areaId:''}, {areaId:''}],//每个下拉框的areaId
      registerImgArr: [
        {src:require('../images/bannerImg/regbanner01.png'),title:'轮播图1',alt:'轮播图1',href:'javascript:;'},
        {src:require('../images/bannerImg/regbanner02.png'),title:'轮播图2',alt:'轮播图2',href:'javascript:;'},
        {src:require('../images/bannerImg/regbanner03.png'),title:'轮播图3',alt:'轮播图3',href:'javascript:;'},
      ],
      Timenum:180,//发送验证码的间隔时间
      forminput: [
        {icon:'\ue606',name:'name',string:'请输入常用的手机号',type:'input'},
        {icon:'\ue605',name:'password',string:'请输入密码',type:'input',password:'show-password'},
        {name:'areaId',type:'selects',},
        {icon:'\ue60e',name:'userCode',string:'手机验证码',type:'input',button:true,disabled:false,btnstr:'获取验证码'},
        // {icon:'\ue608',name:'isOrganization',string:'注册会员类型',type:'select'},
      ],
      userType: [
        {label:'单位',value:true},
        {label:'个人',value:false}
      ],
      titleArr: [
        {color:'#FF703E',icon:'\ue694',title:'司法公正权威',str:'只需5秒成为会员，您将获得更多体验',fontsize:'18px',top:'17px',left:'10px'},
        {color:'#6B82E5',icon:'\ue616',title:'打官司 找律师',str:'竞成法律服务，权威公正法律援助'},
        {color:'#52C870',icon:'\ue60a',title:'找工作 找人才',str:'足不出户，一视而成'},
        {color:'#0099FF',icon:'\ue65e',title:'体验智能化',str:'视频话，智能化，立体化'}
      ]
    }
  },
  computed: {
    provinceId() { return this.placeData[0] },
    cityId() { return this.placeData[1] }
  },
  watch: {
    provinceId(val) {
      if (val == '') {
        this.areaGet({ value: { areaId: 0 }, key: 0 })
      } else {
        this.areaGet({ value: { areaId: val }, key: 1 })
      }
    },
    cityId(val) {
      let areaId = this.placeData[0]
      if (val == '') {
        this.areaGet({ value: { areaId: areaId }, key: 1 })
      } else {
        this.areaGet({ value: { areaId: val }, key: 2 })
      }
    }
  },
  methods: {
    // 获取位置
    areaGet(data) {
      this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let response = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.province = response;this.city = [];this.county = []; break
            case 1 : this.city = response;this.county = []; break
            case 2 : this.county = response; break
          }
        } else{
          this._status(res.data)
        }
      })
    },
    // 清空下级
    remoteMethod(value, num) {
      switch(num) {
        case 1: this.placeData[1] = this.placeData[2] = ''; break
        case 2: this.placeData[2]= ''; break
        case 3: break
      }
    },
    //跳转登录页
    goLogin() {
      this.$router.push('/login')
    },
    // 点击发送验证码按钮
    sendCode(obj) {
      let vm = this
      let phone = vm.registerForm.name
      const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
      if (reg.test(phone)) {
        obj.disabled = true;//输入的号码格式正确，按钮变为不可点
        this.$api._user_SendCode({phone:phone}).then(res => {})
        //前端页面效果
        let time = setInterval(() => {
          vm.Timenum--
          obj.btnstr = '('+vm.Timenum+')'+'秒后可重发'
          if (vm.Timenum <= 0 ) {
            clearInterval(time)
            obj.btnstr = '获取验证码'
            obj.disabled = false
            vm.Timenum = 180
          }
        },1000)
      } else {
        this.$message.info('请输入正确的手机号码')
      }
    },
    // 点击注册按钮
    subRegister() {
      let areaIdArr = this.placeData.filter(x => !!x)
      console.log(areaIdArr)
      this.$refs['registerForm'].validate((valid)=>{
        if (valid) {//验证通过
          if (areaIdArr.length == 0) {
            this.$message.info('请选择地区')
          } else {
            let dataobj = {}
            dataobj.name = this.registerForm.name
            dataobj.areaId = parseInt(areaIdArr[areaIdArr.length - 1])
            dataobj.password = this.registerForm.password
            // dataobj.isOrganization = this.registerForm.isOrganization
            // dataobj.personal = !(this.registerForm.isOrganization)
            let code = this.registerForm.userCode
            let phone = this.registerForm.name
            this.$api._user_register(phone, code, dataobj).then(res => {
              if (res.data.status === 0) {
                this.$confirm('注册成功！, 是否跳转登录页面?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.push('/login')
                }).catch(() => {})
              } else if (res.data.status === 8) {
                this.$message.info('该号码已被注册')
              } else if (res.data.status === 17 || res.data.status === 18) {
                this.$message.info('验证码错误或已过期')
              } else {
                this._status(res.data)
              }
            })
          }
        }
      })
    }
  },
  created() {
    this.areaGet({ value: { areaId: 0 }, key: 0 })
  },
}
</script>

<style lang='scss' scoped>
.registerbox{width: 100%;}
.bgbox{
  height: 650px;background: url(../images/log-reg-bg.jpg) no-repeat center center;
  .w1050{
    width: 1050px;margin: 0px auto;height: 580px;justify-content: space-between;align-items: flex-end;
    .bannerbox{width: 560px;height: 520px;}
    .regbox{
      background-color: #fff;border-radius: 5px;width: 390px;height: 500px;padding: 10px 30px;
      .titlename{
        font-size: 18px;line-height: 50px;text-indent: 10px;margin-bottom: 10px;position: relative;
        &:before {content: '';position: absolute;left: 0;top: 15px;width: 3px;height: 20px;background-color: #ec0001;}
        .gologin{position: absolute;right: 0;}
        .gologin:hover{cursor: pointer;color: #1E9FFF;}
      }

      .inputbox{
        position: relative;line-height: 50px;margin-bottom: 25px;
        /deep/.el-input__inner{height: 48px;}
        /deep/.inputItem .el-input__inner{padding: 0 40px;}
        .iconfont{position: absolute;text-align: center;display: inline-block;width: 50px;height: 48px;left: 0px;top: 0px;font-size: 18px;}
        input{height: 48px;width: 390px;line-height: 48px;padding-left: 50px;}
        .areaBox{display: flex;justify-content: space-between;}
        .areaBox .el-select{width: 30%;}
        .areaBox .el-select input{width: 100%;padding: 10px;}
        button{position: absolute;right: 1px;top: 1px;height: 46px;width: 40%;border: 0px;border-radius: 0px 5px 5px 0px;}
      }
      .registerbtn{width: 100%;height: 50px;font-size: 16px;margin-bottom: 15px;}
      .info{font-size: 14px;text-align: center;}
    }
  }
}

.registerbox .w1200{
  height: 115px;margin: 10px auto 30px;
  ul li{
    padding: 30px 0;width: 25%;display: flex;align-items: flex-start;
    .yuan{display: inline-block;width: 55px;height: 55px;border: 1px solid;border-radius: 50%;}
    .yuan i{font-size: 36px;line-height: 55px;margin-left: 10px;}
    .cont{display: inline-block;height: 55px;margin-left: 10px;}
    .cont .title{color: #666;line-height: 27px;font-size: 18px;font-weight: 400;}
    .cont .str{font-size: 12px;line-height: 18px;color: #999;}
  }
}
</style>